// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconAngleLeft = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18">
            <path
                fill="currentColor"
                d="M7.01540637,16.1482893 L0.307593584,9.02328926 C0.102515459,8.80649239 0,8.52828938 0,8.24985176 C0,7.97150785 0.102562666,7.69297653 0.307594299,7.47641426 L7.01540709,0.351414263 C7.44314146,-0.0997576122 8.15493822,-0.11874193 8.60587549,0.30746895 C9.06000066,0.735203325 9.07603168,1.45028168 8.6498208,1.89840656 L2.63107109,8.24996906 L8.6498208,14.6015316 C9.07610178,15.0497509 9.05997705,15.7616878 8.60587549,16.1924692 C8.1591568,16.6170393 7.44665694,16.5982895 7.01540709,16.1482893 L7.01540637,16.1482893 Z"
                transform="translate(.79 .75)"
            />
        </svg>
    );
};

export default IconAngleLeft;
